<template>
    <li :class="{'on': isSelected}" @click.stop="action_Select"><span>
        <button class="ellipsis">
        {{ title }}
        </button>
    </span></li>
</template>


<script>
export default {
    props: {
        employee: Object,
        focusedItem: Object,
    },
    computed: {
        isSelected: function() { return this.employee == this.focusedItem },
        title: function() { return this.employee?.title },
    },
    methods: {
        action_Select() {
            this.$emit('selectEmployee', this.employee)
        }
    }
}
</script>